import React from "react";
import "./stylesheets/home.css";
import profilePic from "../assets/profilePic.webp";

const Home = () => {
  const downloadResume = async () => {
    const serverUrl =
      "https://jksingh-portfolio-server.vercel.app/api/downloadFile";

    try {
      const response = await fetch(serverUrl);
      const blob = await response.blob();

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "jyoti_kamal_resume.pdf"; // Specify desired file name for download
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      const driveLink =
        "https://drive.google.com/file/d/14-q-LT3KKqW2LIt2Yfg-mkcs_9QHN6Ul/view";
      window.open(driveLink, "_blank"); // Open the drive link in a new tab/window
    } catch (error) {
      console.error("Error downloading file:", error);
      // Handle any errors that occur during the download
    }
  };

  return (
    <div id="home">
      <div>
        <div data-aos="zoom-in" data-aos-duration="750">
          <img src={profilePic} alt="" />
        </div>
        <div data-aos="zoom-in" data-aos-duration="750">
          <br />
          <br />
          <h3>Hello, my name is</h3>
          <h1>Jyoti Kamal Singh</h1>
          <h2 data-text="Full Stack Developer.">I'm a</h2>
          <a style={{ cursor: "pointer" }} onClick={downloadResume}>
            <button>Resume</button>
          </a>
        </div>
      </div>
    </div>
  );
};

export default Home;
